<template>
  <div class="page">
    <div class="page-hedaer line-bar-bottom">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>区域设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-body list-page">
        <div class="operation">
            <el-button type="primary" @click="handleToAdd">新增社区</el-button>
        </div>

        <div class="list" v-loading="loading">
            <el-table :data="listData">
                <el-table-column prop="province" label="省"></el-table-column>
                <el-table-column prop="city" label="市"></el-table-column>
                <el-table-column prop="district" label="区"></el-table-column>
                <el-table-column prop="street" label="街道"></el-table-column>
                <el-table-column prop="community_name" label="社区"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <a href="javascript: void(0);" class="link active" @click="handleToAdd(scope.row)">编辑</a>
                        <el-divider direction="vertical"></el-divider>
                        <a href="javascript: void(0);" class="link active" @click="handleRemove(scope.row)">删除</a>
                    </template>
                </el-table-column>

                <template slot="empty">
                    <div class="list-null">
                        <img src="../../assets/icons/icon_blank.png" alt="暂无数据" />
                        <p><em>暂无数据</em></p>
                        <p>建议您修改搜索条件后重新再试</p>
                    </div>
                </template>
            </el-table>

            <div class="paginations">
                <el-pagination
                    :current-page="listConfig.currPage"
                    @size-change="handleSizeChange"
                    :page-size="listConfig.pageSize"
                    :page-sizes="[10, 50, 100]"
                    :total="listTotal"
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next, sizes, jumper"
                ></el-pagination>
            </div>
        </div>
    </div>

    <dialogDetail ref="dialogDetail" />
  </div>
</template>

<script>
import { ApiZoneList, ApiZoneDelete } from '@/api/zone';

import dialogDetail from './components/dialogDetail';


export default {
  name: 'zonePage',
  components: {
    dialogDetail,
  },
  data() {
    return {
      loading: false,

      // 表格数据
      listData: [],
      listTotal: 0,

      // 列表请求参数
      listConfig: {
        sysUserId: this.$store.getters.userId,
        currPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {},
  mounted() {
    this.handleGetList();
  },
  methods: {
    // 当前页面
    handleCurrentChange(page) {
      this.listConfig.currPage = page;

      this.handleGetList();
    },

    // 每页显示数量
    handleSizeChange(size) {
      this.listConfig.pageSize = size;
      this.listConfig.currPage = 1;

      this.handleGetList();
    },

    // 搜索
    handleSearch() {
      this.listConfig.currPage = 1;

      this.handleGetList();
    },

    // 调用列表Api
    handleGetList() {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      ApiZoneList(this.listConfig).then((res) => {
        this.loading = false;

        this.listData = res.data.list;
        this.listTotal = res.data.total;
      }).catch(() => {
        this.loading = false;
      });
    },

    // 新增
    handleToAdd(row) {
      this.$refs.dialogDetail.handleOpen(row);
    },

    // 删除
    handleRemove(row) {
      // 判断有没有隔离状态的住户 > 0 有 0 无
      const isIsolation = row.isolation_num > 0;
      let tmpMsg = '确定要删除社区 ' + row.community_name + ' 吗？将清除其下所有报警记录';

      if (isIsolation) {
        tmpMsg = '目前仍有处于隔离期的住户，该社区无法删除';
      }

      this.$confirm('<div class="custom-message-title">删除确认</div><div class="custom-message-content">' + tmpMsg + '</div>', {
        customClass: 'custom-message',
        dangerouslyUseHTMLString: true,
        showCancelButton: !isIsolation,
        type: 'warning',
      }).then(() => {
        if (!isIsolation) {
            ApiZoneDelete(row.community_id).then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });

              this.handleGetList();
            }).catch(() => {});
        }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
